var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEventsNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.00012H19.9998C21.0978 4.00012 21.9917 4.89352 21.9919 5.992V20.0082C21.9919 21.1062 21.3577 22.0001 20.2597 22.0001H3.99188C2.89373 22.0001 2 21.106 2 20.0082V5.992C2 4.89352 2.89373 4.00012 3.99188 4.00012H6V2.96793C6 2.4334 6.43312 2.00012 6.96765 2.00012L7.03235 2C7.56672 2 8 2.43328 8 2.96782V4L16 4.00012V2.96793C16 2.4334 16.4331 2.00012 16.9677 2.00012H17.032C17.5667 2.00012 18 2.4334 18 2.96793V4.00012ZM3.99188 20.0001H20V9.00006H3.99188V20.0001Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86437 15.5153L9.58282 17.258C9.54445 17.4962 9.63825 17.7363 9.82541 17.8785C10.0129 18.0204 10.2618 18.0394 10.4666 17.9275L11.97 17.1097L13.4735 17.9277C13.5624 17.9758 13.6599 18 13.7564 18C13.8827 18 14.0087 17.9588 14.115 17.8787C14.3023 17.7365 14.3964 17.4964 14.3577 17.2581L14.0764 15.5154L15.287 14.2779C15.4526 14.1089 15.5115 13.8567 15.4405 13.6272C15.3692 13.3978 15.1784 13.2299 14.9493 13.1947L13.2718 12.9354L12.5162 11.3529C12.4138 11.1368 12.2014 11 11.9699 11C11.7388 11 11.5266 11.1368 11.4233 11.3529L10.6684 12.9354L8.99091 13.1945C8.76141 13.2298 8.57145 13.3977 8.5 13.627C8.42855 13.8566 8.48736 14.1091 8.6532 14.2778L9.86437 15.5153Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventsNav);
export default __webpack_public_path__ + "static/media/icon-events-nav.e2c05c6309bffebbf58e308ef3327409.svg";
export { ForwardRef as ReactComponent };